import React from 'react';
import { Table, Row, Col } from 'fpay-ui';
import PropTypes from 'prop-types';

const Operation = ({ dataHeader, dataBody, properity = [] }) => (
  <Table>
    {dataHeader && (
      <Row header>
        {dataHeader?.map((el, k) => (
          <Col key={`key-header-${k}`} header RightHeader {...properity[k]}>
            {el}
          </Col>
        ))}
      </Row>
    )}
    {dataBody &&
      dataBody?.map((el, l) => (
        <Row key={`key-rbody-${l}`}>
          {el?.map((el2, i) => (
            <Col key={`key-body-${i}`} datajs={dataHeader[i]} {...properity[i]}>
              {el2}
            </Col>
          ))}
        </Row>
      ))}
  </Table>
);

export default Operation;

Operation.propTypes = {
  dataHeader: PropTypes.array,
  dataBody: PropTypes.array,
  properity: PropTypes.array,
};

Operation.defaultProps = {
  dataHeader: undefined,
  dataBody: undefined,
  properity: undefined,
};
